import { FInter, FlexBox, useToasts, useIsMobile, useBreakpoint } from '@brg/ui';
import { useAuth } from '../../../core/hooks/auth/useAuth';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { useHistory } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { API, Competition, CompetitionAPI, Endpoints, Nullable, Project, UserSignAPI, GetProjectsByFilterProps, ProjectAPI, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { LayoutConst, bTag, useModal } from '../../../core';
import { ActionsTitle, ActionsWrapper, ActionsColumnBlock, ProjectsCount, MainTitle, ActionBottomButtons, ModalContainer, TagsTitle, SendButton, ExamTitle, CreateButton, ExamFooterButtons, DeselectButton, SubmitButton, SelectedProjectName, SelectedProjectWrapper, SelectedProjectDesc, TagsString, SubtitleTagsString, HeaderSendButton } from './styles';
import { Outer } from 'shared/pages/explore/styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import { BTag } from 'core/components';
import { SendProjectModalWrapper } from './employStyles';
import { CompleteSend } from './SendProjectForEmploy';
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { BTagsGridNew } from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BackButton } from 'shared/pages/notfound/styles';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { BrgButton, BrgButtonThin } from 'shared/components/buttons';
import { useDispatch } from 'react-redux';
import urlApi from 'shared/actions/urlApi';
import { CompetitionActionPanelActions } from 'shared/reducers/CompetitionActionPanel';
import CompetitionSelectPanel from 'shared/navbars/CompetitionPanel/CompetitionSelectPanel';
import useCompetitionActions from 'shared/hooks/useCompetitionActions';
import SendProjectCheckbox from './SendProjectsCheckbox';

const hseDomains: Record<string, string> = { en: process.env.REACT_APP_URL_HSEDESIGN_COM || '', ru: process.env.REACT_APP_URL_HSEDESIGN_RU || '' }


export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const SortingType = styled.div`

`

export const NeedLogin = (props: { competition?: Competition }) => {
  const auth = useAuth();
  const history = useHistory();
  const theme = useTheme();
  return (
    <Outer>
      <FlexBox style={{ flexFlow: "column" }} offsetTop={24} offsetRight={20} offsetLeft={20}>
        <div style={{ marginBottom: '40px' }}>
          <BackLink onClick={() => history.push('/competition/' + props.competition?.competitionId)}>
            <span>←</span> {props.competition?.name}
          </BackLink>
        </div>
        <ActionsColumnBlock>
          <FInter.TextDiv color={theme.competition.frameMainText}>
            Для того, чтобы отправить работу на участие в конкурсе <b>{props.competition?.name}</b> необходимо войти
          </FInter.TextDiv>
          <FlexBox offsetTop={20}>
            <SendProjectButton onClick={() => auth.login()}>Войти</SendProjectButton>
          </FlexBox>
        </ActionsColumnBlock>
      </FlexBox>
    </Outer>);
};


export const NeedProject = ({ competition }: { competition?: Competition }) => {
  const modal = useModal();

  const { t } = useTranslation();

  const closeModal = () => {
    modal.hide();
  }

  const { goToProfile, handleCreateProject, tagString, tags, isExam } = useCompetitionActions(competition);

  return <FlexBox width={'100%'} widthMobile={'calc(100% - 32px)'} offsetTop={96} justify='center' align='center' offsetLeftMobile={16} offsetRightMobile={16}>
    <FlexBox direction={'column'} gy={20}>
      <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'center'} align={'center'}>
        {isExam && <ExamTitle>Нет соответствующих проектов</ExamTitle>}
        <TagsTitle isExam={isExam}>
          {t(isExam ? 'competition_edit.dont_have_any_project_exam' : 'competition_edit.dont_have_any_project')}
        </TagsTitle>
        <TagsString>
          {!isExam && t('competition_edit.create_project_with_tags') + tagString}
        </TagsString>
        {!!tags?.length && isExam && (
          <BTagsGridNew justify='center' style={isExam ? { width: 'max-content', marginTop: '16px' } : { marginTop: '16px' }}>
            {tags?.map((i) => {
              return (
                <BTag
                  tag={i}
                  educational={i.isEducationTag}
                  isProjectsTag
                  key={i.tagId}
                >
                  {bTag.title(i)}
                </BTag>
              )
            })}

          </BTagsGridNew>
        )}
        {isExam ? (
          <FlexBox offsetTop={40} gx={24}>
            <BrgButtonThin variant='secondary' onClick={closeModal}>Назад</BrgButtonThin>
            <BrgButtonThin onClick={handleCreateProject}>Создать проект</BrgButtonThin>
          </FlexBox>
        ) : (
          <FlexBox offsetTop={40} gx={24}>
            <BrgButtonThin variant='secondary' onClick={goToProfile}>{t('competition_edit.my_projects')}</BrgButtonThin>
            <BrgButtonThin onClick={handleCreateProject}>{t('competition_edit.create_project')}</BrgButtonThin>
          </FlexBox>
        )}
      </FlexBox>
    </FlexBox>
  </FlexBox>
};

interface IProps {
  id: string;
  onApplyClick?: () => void;
  selectedProjectId?: string;
}

export const SendProjectModal: FC<IProps> = ({ id: competitionId, onApplyClick: onPayApplyClick, selectedProjectId }) => {
  const profile = useProfile();
  const [competition, setCompetition] = useState<Competition>();
  //const [time, setT] = useState(new Date().getTime());
  const isMobile = useIsMobile();
  const { i18n, t } = useTranslation();

  const [sorting, setSorting] = useState(1);
  const modal = useModal();
  const [projects, setProjects] = useState<Project[]>([]);
  const [isSendWithoutProject, setIsSendWithoutProject] = useState(false);
  const [showWithoutProjectsModal, setShowWithoutProjectsModal] = useState(false);
  //const [isLegalsSigned, setLegalsSigned] = useState<boolean>(false);
  const hasCalledOnApplyClick = useRef(false); // Флаг для предотвращения повторных вызовов

  const [{ allowedInfo, allowedStatus }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);
  const {
    handleCreateProject,
    tagString,
    isExam,
    selectedProjects,
    setSelectedProjects,
    isPaidApplication,
    shouldDisplayNoProjectsCheckbox,
    handleSubmitFor,
    getLegalsModal,
    canApplyWithoutProject,
    needToFillForm,
    onApplyClick,
  } = useCompetitionActions(competition);


  useEffect(() => {
    if (competitionId) {
      CompetitionAPI.Get({ idCompetition: competitionId })
        .then(v => v.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [i18n.language, competitionId]);

  const alreadyProjects = useMemo(() => {
    return projects.reduce((acc, p) => {
      if (p?.competitionApproves && (!!p?.competitionApproves?.length || !!p?.pendingCompetitionIds?.length) && competitionId) {
        //@ts-ignore
        if (!!p.competitionApproves?.find?.(({ competitionId }) => competitionId === competition?.competitionId) || p?.pendingCompetitionIds?.includes(competitionId)) // условие необходимо если проекты смогут быть в разных конкурсах
          return [...acc, p?.projectId];
      }
      return acc;
    }, [])
  }, [projects])

  const competitionTags: string[] = useMemo(
    () => {
      if (competition) {
        return [
          ...competition?.tags,
          ...competition?.regularTags,
          ...competition?.requredTags
        ]
          ?.map((tag) => tag?.tagId) || []
      }

      return [];
    }, [competition])

  const filterOpt = useMemo(() => {
    if (profile && profile.accountId && competitionId && competition) {
      if (!!competitionTags?.length) {
        return {
          authorIds: [profile.accountId],
          projectFilter: sorting,
          isContextIgnored: true,
          projectStatus: [1, 7],
          exceptCompetitionIds: [competitionId],
          onlyAuthors: false,
          tagIds: competitionTags,
        }
      } else {
        return {
          authorIds: [profile.accountId],
          projectFilter: sorting,
          isContextIgnored: true,
          projectStatus: [1, 7],
          exceptCompetitionIds: [competitionId],
          onlyAuthors: false,
          onlyBooks: ' '
        }
      }
    }
  },
    [competitionId, profile, sorting, competitionTags, competition]
  );

  useEffect(() => {
    if (filterOpt) {
      ProjectAPI.GetList(filterOpt).then((r) => r.json()).then((r) => {
        setProjects(API.toLang(r?.data, i18n.language))
      })
    }
  }, [filterOpt, i18n])

  const haveProjects = projects?.length > 0
  //@ts-ignore

  useEffect(() => {
    if (profile && profile.accountId) {
      UserSignAPI.CheckSignsDocuments({
        service: ['competitions'],
        userId: profile.accountId
      })
        .then(d => {
          if (d.status === 200) return d.json(); // список доков
          //if (d.status === 204) setLegalsSigned(false); // у юзера нет неподписанных доков
        })
        .then((d: any) => {
          // //@ts-ignore
          // if (d && competition && competition?.nominations && competition?.nominations[0]?.documentsIds){
          //   //@ts-ignore
          //   const needSign = d.some(x => competition?.nominations[0]?.documentsIds.includes(x));
          //   //setLegalsSigned(needSign);
          //   // d.map((i) => {
          //   //   //@ts-ignore
          //   //   setLegalsSigned(competition?.nominations[0]?.documentsIds.includes(i.documentId))
          //   // })
          // }
        })
    }
  }, [profile, competition]);

  const [userPaidCard, setUserPaidCard] = useState(false);

  useEffect(() => {
    if (isPaidApplication && competitionId) {
      API.request()
        .endpoint(Endpoints.competitions)
        .url('/api/Competition/GetUserCompetitionCards')
        .addQuery('competitionId', competitionId)
        .get()
        .send()
        .then(response => response.json())
        .then(competitionCard => {
          setUserPaidCard(!!competitionCard.length)
        })
        .catch(error => {
          setUserPaidCard(false);
        });
    } else {
      setUserPaidCard(false);
    }

  }, [competitionId, isPaidApplication]);

  const onSendWithoutProjects = useCallback(() => {
    setIsSendWithoutProject(!isSendWithoutProject);
  }, [isSendWithoutProject])


  const maxProjects = useMemo(() => {
    if (isPaidApplication && !userPaidCard) {
      return 1;
    }
    return (allowedStatus?.allowedMax || 0) - (allowedStatus?.allowedCurrent || 0);
  }, [isPaidApplication, userPaidCard, allowedStatus]);

  // Автоматически выбираем проект при возврате от экваиринга
  useEffect(() => {
    if (selectedProjectId && projects.length > 0 && !hasCalledOnApplyClick.current) {
      const projectExists = projects.some(project => project.projectId === selectedProjectId);

      if (projectExists && !selectedProjects.includes(selectedProjectId)) {
        setSelectedProjects([selectedProjectId]);
        // Автоматически вызываем onApplyClick если это возврат от экваиринга
        if (onPayApplyClick) {
          hasCalledOnApplyClick.current = true; // Устанавливаем флаг
          setTimeout(() => {
            // Вызываем onApplyClick с актуальным selectedProjectId напрямую
            onApplyClick({
              id: competitionId || '',
              forceSelectedProjectId: selectedProjectId,
            });
          }, 100);
        }
      }
    }
  }, [selectedProjectId, projects, selectedProjects, onPayApplyClick])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    //setT(Date.now());
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        sorting={sorting}
        hideRightBar={false}
        hideLeftBar={true}
        hideRightButtons
        onSortingChange={onSortingChange}
        isTagPage={false}
        projectCount={projects?.length}
      />
    ),
    [
      sorting,
      onSortingChange,
      projects,
    ],
  );

  const handleSendWihoutProject = () => {
    const confirm = window.confirm(`Подать заявку на участие без проекта?`)

    if (confirm) {
      try {
        API.request()
          .endpoint(Endpoints.competitions)
          .url('/api/Competition/RequestParticipantToCompetition')
          .post()
          .addQuery('competitionId', competition?.competitionId || '')
          .send()
          .then((r) => {
            if (r?.status === 200) {
              setShowWithoutProjectsModal(true);
            }
          })
      }
      catch (err) {
        console.error('Что-то пошло не так');
      }
    }
  }

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
  }, [sorting, setSorting]);
  const selectedProjectName = useMemo(() => {
    if (selectedProjects.length === 0) return '';
    const selectedProject = projects.find(p => p.projectId === selectedProjects[0]);
    return selectedProject?.title || '';
  }, [selectedProjects, projects]);

  const handleDeselectProject = useCallback(() => {
    setSelectedProjects([]);
  }, []);

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (alreadyProjects && alreadyProjects.length > 0) {
      return data ? alreadyProjects.includes(data) : false;
    }
  }, [alreadyProjects])

  const noProjectsRequestCheckbox = useMemo(() => (
    <SendProjectCheckbox text={t('teams.modal.without_projects')} checked={isSendWithoutProject} onClick={onSendWithoutProjects} />
  ), [onSendWithoutProjects, t, isSendWithoutProject])

  const disableSend = useMemo(
    () => (canApplyWithoutProject ? (!isSendWithoutProject && selectedProjects?.length === 0) : selectedProjects?.length === 0)
    , [isSendWithoutProject, selectedProjects, canApplyWithoutProject])

  const allProjectsSelected = useMemo(() => {
    return projects.length === selectedProjects.length;
  }, [projects, selectedProjects]);

  const selectProject = useCallback((projectId: string) => {
    setSelectedProjects((prev: string[]) => {
      if (isExam) return [projectId]
      if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
      return [...prev, projectId];
    });
  }, [isExam, setSelectedProjects]);

  if (!profile) {
    return <NeedLogin competition={competition} />
  }

  const handleSubmit = () => {
    if (isSendWithoutProject && selectedProjects?.length === 0) {
      handleSendWihoutProject();
    } else if (isPaidApplication && !userPaidCard) {
      handleSubmitFor({
        projectName: selectedProjectName,
      });
    } else {
      getLegalsModal(needToFillForm, onApplyClick);
    }
  }

  const handleSelectAll = () => {
    if (allProjectsSelected) {
      setSelectedProjects([]);
    } else {
      setSelectedProjects(projects.map(p => p.projectId));
    }
  }

  const shouldDisplayTagsString = !!tagString?.length && haveProjects;

  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%' }} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      <SendProjectModalWrapper directionMobile='column' justify={isMobile ? 'flex-start' : 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative' }}>
        <ActionsWrapper hide={showWithoutProjectsModal} direction="column" style={{ justifyContent: 'center', position: 'relative', width: '100%' }}>
          <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' width={'100%'} >
            <FlexBox direction='column' directionMobile='column'>
              {<MainTitle>
                {isPaidApplication ? t('competition.pay_title') : t('competition.select_project')}
              </MainTitle>}
              {shouldDisplayTagsString && (
                <SubtitleTagsString align='left'>
                  {t('competition_edit.create_project_with_tags') + tagString}
                </SubtitleTagsString>
              )}
            </FlexBox>
            {haveProjects && (
              <HeaderSendButton variant="secondary" onClick={handleCreateProject}>
                {t('competition.create_new_project')}
              </HeaderSendButton>
            )}
          </ActionsTitle>
          {(haveProjects || canApplyWithoutProject) && (
            <FlexBox offsetBottom={20} direction='row' justify='space-between' align='center'>
              {shouldDisplayNoProjectsCheckbox ? noProjectsRequestCheckbox : (
                <SendProjectCheckbox
                  onClick={handleSelectAll}
                  checked={allProjectsSelected}
                  text={t('competition.select_all')}
                />
              )}
              {
                isMobile ?
                  (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                      <SortIcon />
                      {/* Sort */}
                      <SortingType>{sorting === 1 ? t('sorting_type.latest') : t('sorting_type.popular')}</SortingType>
                    </MobileFilterSort>
                  ) :
                  searchBar}
            </FlexBox>
          )}
          {!haveProjects && competition && <NeedProject competition={competition} />}
          {filterOpt && (
            <ProjectsGridNew k={undefined} isLoading={false}>
              {projects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                return (
                  // @ts-ignore
                  <ProjectCardNew
                    project={v as any}
                    isModal={false}
                    withoutGoToProject={true}
                    onProjectClick={(projectId?: string, e?: any) => {
                      e?.stopPropagation();
                      e?.preventDefault();
                      selectProject(projectId);
                    }}
                    isSelectable={true}
                    //@ts-ignore
                    isRejected={ProjectDelegate.isRejectedProject(v)}
                    key={(v?.projectId || '') + index}
                    {...computeProject(v)}
                    // isSelectRightNeed={isMobile}
                    metaAlwaysVisible
                    selectRingPosition={RingPositions.right}
                    onSelect={(projectId) => {
                      selectProject(projectId);
                    }}
                    selected={selectedProjects?.includes(v?.projectId ?? '')}
                    alreadyProject={isAlreadyProject(v?.projectId)}
                  />
                );

              })}
            </ProjectsGridNew>
          )}
        </ActionsWrapper>
        {!showWithoutProjectsModal && (
          <CompetitionSelectPanel
            isEmptyRequest={isSendWithoutProject}
            selectedCount={selectedProjects?.length}
            selectedProjectName={selectedProjectName}
            maxProjects={maxProjects}
            onDeselect={handleDeselectProject}
            onPublish={handleSubmit}
            disabled={disableSend}
          />
          )}
        {showWithoutProjectsModal && <CompleteSend isCompetition title={competition?.name || ''} contextName={''} withoutProjects={true} />}
      </SendProjectModalWrapper>
    </ModalContainer>
  );
};
import { FInter, FlexBox, useToasts, useIsMobile, useBreakpoint } from '@brg/ui';
import { useAuth } from '../../../core/hooks/auth/useAuth';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { MobileFilterSort } from 'shared/pages/explore/exploreView';
import { SortIcon } from 'shared/icons';
import { useHistory } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { API, Competition, CompetitionAPI, Endpoints, Nullable, Project, UserSignAPI, GetProjectsByFilterProps, ProjectAPI, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { LayoutConst, bTag, useModal } from '../../../core';
import { ActionsTitle, ActionsWrapper, ActionsColumnBlock, ProjectsCount, MainTitle, ActionBottomButtons, ModalContainer, TagsTitle, SendButton, ExamTitle, CreateButton, ExamFooterButtons, DeselectButton, SubmitButton, SelectedProjectName, SelectedProjectWrapper, SelectedProjectDesc, TagsString, SubtitleTagsString, HeaderSendButton } from './styles';
import { Outer } from 'shared/pages/explore/styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import { BTag } from 'core/components';
import { SendProjectModalWrapper } from './employStyles';
import { CompleteSend } from './SendProjectForEmploy';
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { BTagsGridNew } from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BackButton } from 'shared/pages/notfound/styles';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { BrgButton, BrgButtonThin } from 'shared/components/buttons';
import { useDispatch } from 'react-redux';
import urlApi from 'shared/actions/urlApi';
import { CompetitionActionPanelActions } from 'shared/reducers/CompetitionActionPanel';
import CompetitionSelectPanel from 'shared/navbars/CompetitionPanel/CompetitionSelectPanel';
import useCompetitionActions from 'shared/hooks/useCompetitionActions';
import SendProjectCheckbox from './SendProjectsCheckbox';

const hseDomains: Record<string, string> = { en: process.env.REACT_APP_URL_HSEDESIGN_COM || '', ru: process.env.REACT_APP_URL_HSEDESIGN_RU || '' }


export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const SortingType = styled.div`

`

export const NeedLogin = (props: { competition?: Competition }) => {
  const auth = useAuth();
  const history = useHistory();
  const theme = useTheme();
  return (
    <Outer>
      <FlexBox style={{ flexFlow: "column" }} offsetTop={24} offsetRight={20} offsetLeft={20}>
        <div style={{ marginBottom: '40px' }}>
          <BackLink onClick={() => history.push('/competition/' + props.competition?.competitionId)}>
            <span>←</span> {props.competition?.name}
          </BackLink>
        </div>
        <ActionsColumnBlock>
          <FInter.TextDiv color={theme.competition.frameMainText}>
            Для того, чтобы отправить работу на участие в конкурсе <b>{props.competition?.name}</b> необходимо войти
          </FInter.TextDiv>
          <FlexBox offsetTop={20}>
            <SendProjectButton onClick={() => auth.login()}>Войти</SendProjectButton>
          </FlexBox>
        </ActionsColumnBlock>
      </FlexBox>
    </Outer>);
};


export const NeedProject = ({ competition }: { competition?: Competition }) => {
  const modal = useModal();

  const { t } = useTranslation();

  const closeModal = () => {
    modal.hide();
  }

  const { goToProfile, handleCreateProject, tagString, tags, isExam } = useCompetitionActions(competition);

  return <FlexBox width={'100%'} widthMobile={'calc(100% - 32px)'} offsetTop={96} justify='center' align='center' offsetLeftMobile={16} offsetRightMobile={16}>
    <FlexBox direction={'column'} gy={20}>
      <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'center'} align={'center'}>
        {isExam && <ExamTitle>Нет соответствующих проектов</ExamTitle>}
        <TagsTitle isExam={isExam}>
          {t(isExam ? 'competition_edit.dont_have_any_project_exam' : 'competition_edit.dont_have_any_project')}
        </TagsTitle>
        <TagsString>
          {!isExam && t('competition_edit.create_project_with_tags') + tagString}
        </TagsString>
        {!!tags?.length && isExam && (
          <BTagsGridNew justify='center' style={isExam ? { width: 'max-content', marginTop: '16px' } : { marginTop: '16px' }}>
            {tags?.map((i) => {
              return (
                <BTag
                  tag={i}
                  educational={i.isEducationTag}
                  isProjectsTag
                  key={i.tagId}
                >
                  {bTag.title(i)}
                </BTag>
              )
            })}

          </BTagsGridNew>
        )}
        {isExam ? (
          <FlexBox offsetTop={40} gx={24}>
            <BrgButtonThin variant='secondary' onClick={closeModal}>Назад</BrgButtonThin>
            <BrgButtonThin onClick={handleCreateProject}>Создать проект</BrgButtonThin>
          </FlexBox>
        ) : (
          <FlexBox offsetTop={40} gx={24}>
            <BrgButtonThin variant='secondary' onClick={goToProfile}>{t('competition_edit.my_projects')}</BrgButtonThin>
            <BrgButtonThin onClick={handleCreateProject}>{t('competition_edit.create_project')}</BrgButtonThin>
          </FlexBox>
        )}
      </FlexBox>
    </FlexBox>
  </FlexBox>
};

interface IProps {
  id: string;
  onApplyClick?: () => void;
  selectedProjectId?: string;
}

export const SendProjectModal: FC<IProps> = ({ id: competitionId, onApplyClick: onPayApplyClick, selectedProjectId }) => {
  const profile = useProfile();
  const [competition, setCompetition] = useState<Competition>();
  //const [time, setT] = useState(new Date().getTime());
  const isMobile = useIsMobile();
  const { i18n, t } = useTranslation();

  const [sorting, setSorting] = useState(1);
  const modal = useModal();
  const [projects, setProjects] = useState<Project[]>([]);
  const [isSendWithoutProject, setIsSendWithoutProject] = useState(false);
  const [showWithoutProjectsModal, setShowWithoutProjectsModal] = useState(false);
  //const [isLegalsSigned, setLegalsSigned] = useState<boolean>(false);
  const hasCalledOnApplyClick = useRef(false); // Флаг для предотвращения повторных вызовов

  const [{ allowedInfo, allowedStatus }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);
  const {
    handleCreateProject,
    tagString,
    isExam,
    selectedProjects,
    setSelectedProjects,
    isPaidApplication,
    shouldDisplayNoProjectsCheckbox,
    handleSubmitFor,
    getLegalsModal,
    canApplyWithoutProject,
    needToFillForm,
    onApplyClick,
  } = useCompetitionActions(competition);


  useEffect(() => {
    if (competitionId) {
      CompetitionAPI.Get({ idCompetition: competitionId })
        .then(v => v.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [i18n.language, competitionId]);

  const alreadyProjects = useMemo(() => {
    return projects.reduce((acc, p) => {
      if (p?.competitionApproves && (!!p?.competitionApproves?.length || !!p?.pendingCompetitionIds?.length) && competitionId) {
        //@ts-ignore
        if (!!p.competitionApproves?.find?.(({ competitionId }) => competitionId === competition?.competitionId) || p?.pendingCompetitionIds?.includes(competitionId)) // условие необходимо если проекты смогут быть в разных конкурсах
          return [...acc, p?.projectId];
      }
      return acc;
    }, [])
  }, [projects])

  const competitionTags: string[] = useMemo(
    () => {
      if (competition) {
        return [
          ...competition?.tags,
          ...competition?.regularTags,
          ...competition?.requredTags
        ]
          ?.map((tag) => tag?.tagId) || []
      }

      return [];
    }, [competition])

  const filterOpt = useMemo(() => {
    if (profile && profile.accountId && competitionId && competition) {
      if (!!competitionTags?.length) {
        return {
          authorIds: [profile.accountId],
          projectFilter: sorting,
          isContextIgnored: true,
          projectStatus: [1, 7],
          exceptCompetitionIds: [competitionId],
          onlyAuthors: false,
          tagIds: competitionTags,
        }
      } else {
        return {
          authorIds: [profile.accountId],
          projectFilter: sorting,
          isContextIgnored: true,
          projectStatus: [1, 7],
          exceptCompetitionIds: [competitionId],
          onlyAuthors: false,
          onlyBooks: ' '
        }
      }
    }
  },
    [competitionId, profile, sorting, competitionTags, competition]
  );

  useEffect(() => {
    if (filterOpt) {
      ProjectAPI.GetList(filterOpt).then((r) => r.json()).then((r) => {
        setProjects(API.toLang(r?.data, i18n.language))
      })
    }
  }, [filterOpt, i18n])

  const haveProjects = projects?.length > 0
  //@ts-ignore

  useEffect(() => {
    if (profile && profile.accountId) {
      UserSignAPI.CheckSignsDocuments({
        service: ['competitions'],
        userId: profile.accountId
      })
        .then(d => {
          if (d.status === 200) return d.json(); // список доков
          //if (d.status === 204) setLegalsSigned(false); // у юзера нет неподписанных доков
        })
        .then((d: any) => {
          // //@ts-ignore
          // if (d && competition && competition?.nominations && competition?.nominations[0]?.documentsIds){
          //   //@ts-ignore
          //   const needSign = d.some(x => competition?.nominations[0]?.documentsIds.includes(x));
          //   //setLegalsSigned(needSign);
          //   // d.map((i) => {
          //   //   //@ts-ignore
          //   //   setLegalsSigned(competition?.nominations[0]?.documentsIds.includes(i.documentId))
          //   // })
          // }
        })
    }
  }, [profile, competition]);

  const [userPaidCard, setUserPaidCard] = useState(false);

  useEffect(() => {
    if (isPaidApplication && competitionId) {
      API.request()
        .endpoint(Endpoints.competitions)
        .url('/api/Competition/GetUserCompetitionCards')
        .addQuery('competitionId', competitionId)
        .get()
        .send()
        .then(response => response.json())
        .then(competitionCard => {
          setUserPaidCard(!!competitionCard.length)
        })
        .catch(error => {
          setUserPaidCard(false);
        });
    } else {
      setUserPaidCard(false);
    }

  }, [competitionId, isPaidApplication]);

  const onSendWithoutProjects = useCallback(() => {
    setIsSendWithoutProject(!isSendWithoutProject);
  }, [isSendWithoutProject])


  const maxProjects = useMemo(() => {
    if (isPaidApplication && !userPaidCard) {
      return 1;
    }
    return (allowedStatus?.allowedMax || 0) - (allowedStatus?.allowedCurrent || 0);
  }, [isPaidApplication, userPaidCard, allowedStatus]);

  // Автоматически выбираем проект при возврате от экваиринга
  useEffect(() => {
    if (selectedProjectId && projects.length > 0 && !hasCalledOnApplyClick.current) {
      const projectExists = projects.some(project => project.projectId === selectedProjectId);

      if (projectExists && !selectedProjects.includes(selectedProjectId)) {
        setSelectedProjects([selectedProjectId]);
        // Автоматически вызываем onApplyClick если это возврат от экваиринга
        if (onPayApplyClick) {
          hasCalledOnApplyClick.current = true; // Устанавливаем флаг
          setTimeout(() => {
            // Вызываем onApplyClick с актуальным selectedProjectId напрямую
            onApplyClick({
              id: competitionId || '',
              forceSelectedProjectId: selectedProjectId,
            });
          }, 100);
        }
      }
    }
  }, [selectedProjectId, projects, selectedProjects, onPayApplyClick])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    //setT(Date.now());
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        sorting={sorting}
        hideRightBar={false}
        hideLeftBar={true}
        hideRightButtons
        onSortingChange={onSortingChange}
        isTagPage={false}
        projectCount={projects?.length}
      />
    ),
    [
      sorting,
      onSortingChange,
      projects,
    ],
  );

  const handleSendWihoutProject = () => {
    const confirm = window.confirm(`Подать заявку на участие без проекта?`)

    if (confirm) {
      try {
        API.request()
          .endpoint(Endpoints.competitions)
          .url('/api/Competition/RequestParticipantToCompetition')
          .post()
          .addQuery('competitionId', competition?.competitionId || '')
          .send()
          .then((r) => {
            if (r?.status === 200) {
              setShowWithoutProjectsModal(true);
            }
          })
      }
      catch (err) {
        console.error('Что-то пошло не так');
      }
    }
  }

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
  }, [sorting, setSorting]);
  const selectedProjectName = useMemo(() => {
    if (selectedProjects.length === 0) return '';
    const selectedProject = projects.find(p => p.projectId === selectedProjects[0]);
    return selectedProject?.title || '';
  }, [selectedProjects, projects]);

  const handleDeselectProject = useCallback(() => {
    setSelectedProjects([]);
  }, []);

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (alreadyProjects && alreadyProjects.length > 0) {
      return data ? alreadyProjects.includes(data) : false;
    }
  }, [alreadyProjects])

  const noProjectsRequestCheckbox = useMemo(() => (
    <SendProjectCheckbox text={t('teams.modal.without_projects')} checked={isSendWithoutProject} onClick={onSendWithoutProjects} />
  ), [onSendWithoutProjects, t, isSendWithoutProject])

  const disableSend = useMemo(
    () => (canApplyWithoutProject ? (!isSendWithoutProject && selectedProjects?.length === 0) : selectedProjects?.length === 0)
    , [isSendWithoutProject, selectedProjects, canApplyWithoutProject])

  const allProjectsSelected = useMemo(() => {
    return projects.length === selectedProjects.length;
  }, [projects, selectedProjects]);

  const selectProject = useCallback((projectId: string) => {
    setSelectedProjects((prev: string[]) => {
      if (isExam) return [projectId]
      if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
      return [...prev, projectId];
    });
  }, [isExam, setSelectedProjects]);

  if (!profile) {
    return <NeedLogin competition={competition} />
  }

  const handleSubmit = () => {
    if (isSendWithoutProject && selectedProjects?.length === 0) {
      handleSendWihoutProject();
    } else if (isPaidApplication && !userPaidCard) {
      handleSubmitFor({
        projectName: selectedProjectName,
      });
    } else {
      getLegalsModal(needToFillForm, onApplyClick);
    }
  }

  const handleSelectAll = () => {
    if (allProjectsSelected) {
      setSelectedProjects([]);
    } else {
      setSelectedProjects(projects.map(p => p.projectId));
    }
  }

  const shouldDisplayTagsString = !!tagString?.length && haveProjects;

  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%' }} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      <SendProjectModalWrapper directionMobile='column' justify={isMobile ? 'flex-start' : 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative' }}>
        <ActionsWrapper hide={showWithoutProjectsModal} direction="column" style={{ justifyContent: 'center', position: 'relative', width: '100%' }}>
          <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' width={'100%'} >
            <FlexBox direction='column' directionMobile='column'>
              {<MainTitle>
                {isPaidApplication ? t('competition.pay_title') : t('competition.select_project')}
              </MainTitle>}
              {shouldDisplayTagsString && (
                <SubtitleTagsString align='left'>
                  {t('competition_edit.create_project_with_tags') + tagString}
                </SubtitleTagsString>
              )}
            </FlexBox>
            {haveProjects && (
              <HeaderSendButton variant="secondary" onClick={handleCreateProject}>
                {t('competition.create_new_project')}
              </HeaderSendButton>
            )}
          </ActionsTitle>
          {(haveProjects || canApplyWithoutProject) && (
            <FlexBox offsetBottom={20} direction='row' justify='space-between' align='center'>
              {shouldDisplayNoProjectsCheckbox ? noProjectsRequestCheckbox : (
                <SendProjectCheckbox
                  onClick={handleSelectAll}
                  checked={allProjectsSelected}
                  text={t('competition.select_all')}
                />
              )}
              {
                isMobile ?
                  (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                      <SortIcon />
                      {/* Sort */}
                      <SortingType>{sorting === 1 ? t('sorting_type.latest') : t('sorting_type.popular')}</SortingType>
                    </MobileFilterSort>
                  ) :
                  searchBar}
            </FlexBox>
          )}
          {!haveProjects && competition && <NeedProject competition={competition} />}
          {filterOpt && (
            <ProjectsGridNew k={undefined} isLoading={false}>
              {projects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                return (
                  // @ts-ignore
                  <ProjectCardNew
                    project={v as any}
                    isModal={false}
                    withoutGoToProject={true}
                    onProjectClick={(projectId?: string, e?: any) => {
                      e?.stopPropagation();
                      e?.preventDefault();
                      selectProject(projectId);
                    }}
                    isSelectable={true}
                    //@ts-ignore
                    isRejected={ProjectDelegate.isRejectedProject(v)}
                    key={(v?.projectId || '') + index}
                    {...computeProject(v)}
                    // isSelectRightNeed={isMobile}
                    metaAlwaysVisible
                    selectRingPosition={RingPositions.right}
                    onSelect={(projectId) => {
                      selectProject(projectId);
                    }}
                    selected={selectedProjects?.includes(v?.projectId ?? '')}
                    alreadyProject={isAlreadyProject(v?.projectId)}
                  />
                );

              })}
            </ProjectsGridNew>
          )}
        </ActionsWrapper>
        {!showWithoutProjectsModal && (
          <CompetitionSelectPanel
            isEmptyRequest={isSendWithoutProject}
            selectedCount={selectedProjects?.length}
            selectedProjectName={selectedProjectName}
            maxProjects={maxProjects}
            onDeselect={handleDeselectProject}
            onPublish={handleSubmit}
            disabled={disableSend}
          />
          )}
        {showWithoutProjectsModal && <CompleteSend isCompetition title={competition?.name || ''} contextName={''} withoutProjects={true} />}
      </SendProjectModalWrapper>
    </ModalContainer>
  );
};
